import React, {PropsWithChildren, useRef} from "react";
import {createPortal} from "react-dom";
import {useIsAdmin} from "../../config";


const AdminPortal: React.FC<PropsWithChildren> = (props) => {


    const popupWindow = useRef<Window|null>(null);
    const isAdmin = useIsAdmin();
    if (!isAdmin) return null;

    if (popupWindow.current === null) {
        popupWindow.current = window.open('', 'adminwindow', 'width=600,height=400,left=200,top=200');
    }

    const windowToUse = popupWindow.current;

    const divElem = document.createElement("div");

    if (windowToUse) {

        windowToUse.document.body.replaceChildren(divElem)

    }
    return createPortal(props.children, divElem);

}
export default AdminPortal;